module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Electric/Shutdown-63969d4f3c5d84aa8ae1e7d32169de70.svg";